<script>
import _debounce from "lodash/debounce";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  components: {
    CommonTableComponent
  },
  mixins: [pagination, tableSearch],
  props: ['dataSearch'],
  data() {
    return {
      currentInputSelectData: "",
      header: this.$constant.tableHeaders.common.searchs.product_name,
      busyGetData: false,
      data: [],
      visible: false,
      filters: {
        searchValue: "",
        column: "products.product_cd",
        dir: "DESC",
        page: 1
      }
    };
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.popup_search_products, {
        ...this.filters,
      });
      const { status, data } = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.data = this.$_.isEmpty(result) ? [] : result;
        // const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        // this.setMeta(meta);
      }
    },
    updateValue: function(value) {
      this.dataSearch.product_name = value;
      this.$emit('dataSelected', this.dataSearch)
      this.closeModal();
    },
    openModal() {
      this.$bvModal.show("modal-select-data-product_name");
    },
    closeModal() {
      this.$bvModal.hide("modal-select-data-product_name");
    },
    performDebounceSearch: _debounce(async function () {
      this.resetToFirstPage();
      this.updateUrlFilters();
    }, 600),
    updateUrlFilters () {
      this.getData()
    },
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler() {
        this.updateUrlFilters();
      }
    },
  },
  computed: {
    headers() {
      return this.header;
    },
    inputSearch: {
      get() {
        return this.dataSearch.product_name;
      },
      set(newValue) {
        this.dataSearch.product_name = newValue;
      }
    },
  }
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <label :for="'product_name'" class="col-form-label text-nowrap me-2"
      >請求書表示用商品名</label
    >
    <div class="d-flex w-100">
      <input
        type="text"
        class="form-control me-2"
        id="product_name"
        v-model="inputSearch"
      />
      <b-button @click="openModal()" variant="outline-info"
        ><i class="bx bx-file-find"></i
      ></b-button>
    </div>
    <!-- modal area -->
    <b-modal
      size="xl"
      id="modal-select-data-product_name"
      centered
      title-class="font-18"
      hide-footer
      title="請求書表示用商品名一覧"
      scrollable
      @show="getData"
    >
      <b-row>
        <div>
          <b-form-input
            placeholder="フィルター..."
            v-model="filters.searchValue"
            v-on:keyup.enter="performDebounceSearch"
            type="text"
            id="name"
          ></b-form-input>
        </div>
      </b-row>
      <b-row class="mt-2">
        <b-overlay
          :show="busyGetData"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                  <span v-if="item.sortable" @click="clickSort(item.value)">
                    {{ item.text }}
                    <i :class="getSortClass(item.value)"></i>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in data"
                :key="index"
                class="cursor-pointer"
                @click="updateValue(item.name_abbreviated)"
              >
                <td>
                  {{ item.product_cd }}
                </td>
                <td>
                  {{ item.name_abbreviated }}
                </td>
                <td>
                  {{ item.product_2_name }}
                </td>
              </tr>
              <tr v-if="!data.length && !busyGetData">
                <td :colspan="headers.length" class="text-center">
                  データなし。
                </td>
              </tr>
            </tbody>
          </CommonTableComponent>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
